<script lang="ts" setup>
import Checkbox from '@/components/common/Checkbox.vue';

defineEmits(['change']);

defineProps({
    title: {
        type: String,
        default: ''
    },
    tooltip: {
        type: String,
        default: ''
    },
    checked: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <Checkbox
        v-tooltip="tooltip"
        class="sy-popup-menu-button"
        :checked="checked"
        size="small"
        :data-test="title"
        @change="$emit('change', $event)"
        @keydown.enter="$emit('change', $event)"
    >
        <span class="cell auto sy-truncate">{{ title }}</span>
    </Checkbox>
</template>
